var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",style:(_vm.wrapperStyles)},[_c('p',{style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.item.properties.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }